// extracted by mini-css-extract-plugin
export default {"signUp":"SignUp_signUp__GroNz","title":"SignUp_title__2KeUo","input":"SignUp_input__UsQXE","errorMessageBox":"SignUp_errorMessageBox__E1hqm"};